import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAutoCloseDetails]'
})
export class AutoCloseDetailsDirective {
  constructor(private el: ElementRef<HTMLDetailsElement>) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const details = this.el.nativeElement;
    if (details.open && !details.contains(event.target as Node)) {
      details.open = false;
    }
  }
}
